var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3285_3678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3285_3678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3307C4.30556 18.3307 3.71528 18.0877 3.22917 17.6016C2.74306 17.1155 2.5 16.5252 2.5 15.8307V13.3307H5V1.66406H17.5V15.8307C17.5 16.5252 17.2569 17.1155 16.7708 17.6016C16.2847 18.0877 15.6944 18.3307 15 18.3307H5ZM15 16.6641C15.2361 16.6641 15.434 16.5842 15.5938 16.4245C15.7535 16.2648 15.8333 16.0668 15.8333 15.8307V3.33073H6.66667V13.3307H14.1667V15.8307C14.1667 16.0668 14.2465 16.2648 14.4062 16.4245C14.566 16.5842 14.7639 16.6641 15 16.6641ZM7.5 7.4974V5.83073H15V7.4974H7.5ZM7.5 9.9974V8.33073H15V9.9974H7.5ZM5 16.6641H12.5V14.9974H4.16667V15.8307C4.16667 16.0668 4.24653 16.2648 4.40625 16.4245C4.56597 16.5842 4.76389 16.6641 5 16.6641ZM5 16.6641H4.16667H12.5H5Z",
    fill: "#F5D447"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsIcon);
export default __webpack_public_path__ + "static/media/subscriptions-icon.20f0d4e48be2955763275f8073403ae5.svg";
export { ForwardRef as ReactComponent };